import React from "react";
import FilePage from "../FilePage/FilePage";

class ChequeListAttachment extends React.Component {
  render() {
    const { cheque } = this.props;

    return (
      <FilePage
        table={"cheque"}
        id={cheque.id}
        title={"ضمیمه های چک # " + cheque.id}
        handleBack={this.props.handleBack}
      />
    );
  }
}

export default ChequeListAttachment;
